// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"592b7406","605":"894fe218","725":"e30f0a73"}[chunkId] + ".chunk.js";
};